export default "__VITE_ASSET__CxY$M6tO__"